import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    logo: {
      title: "Anonymator",
      src: { light: "logo-light.png", dark: "logo-dark.png" },
      alt: "Anonymator",
      width: "240px",
    },
    showPoweredBy: false,
  },

  metadata: {
    title: "Anonymator Portal documentation",
    favicon: "/favicon.ico",
  },

  navigation: [
    // --- Documentation tab ---
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            "/introduction",
            {
              type: "link",
              icon: "workflow",
              label: "Integrations",
              // ✅ Redirects to the Integrations section (the tab with its own sidebar)
              to: "/doc-integrations-redirect",
            },
            {
              type: "link",
              icon: "folder-cog",
              badge: {
                label: "NEW",
                color: "purple",
              },
              label: "API Reference",
              to: "/api",
            },
          ],
        },
      ],
    },

    // --- Integrations tab (full sidebar) ---
    {
      type: "category",
      label: "Integrations",
      icon: "workflow",
      items: [
        "integrations/index", // landing page
        {
          type: "category",
          label: "n8n",
          icon: "plug",
          items: [
            "integrations/n8n/n8n-anonymize",
            "integrations/n8n/n8n-deanonymize",
          ],
        },
        {
          type: "category",
          label: "Make.com",
          icon: "plug",
          items: [
            "integrations/make/make-anonymize",
            "integrations/make/make-deanonymize"
          ],
        },
        {
          type: "category",
          label: "Pabbly Connect",
          icon: "plug",
          items: [
            "integrations/pabbly/pabbly-anonymize",
            "integrations/pabbly/pabbly-deanonymize"
          ],
        },
        {
          type: "category",
          label: "Zapier",
          icon: "plug",
          items: [
            "integrations/zapier/zapier-anonymize",
            "integrations/zapier/zapier-deanonymize"
          ],
        },
      ],
    },

    // --- API Reference tab ---
    {
      type: "link",
      label: "API Reference",
      to: "/api",
    },
  ],

  redirects: [{ from: "/", to: "/introduction" }],

  apis: [
    {
      type: "file",
      input: "./apis/openapi.json",
      path: "/api",
    },
  ],
};

export default config;
